import { render, staticRenderFns } from "./userExamPaper.vue?vue&type=template&id=7e604e69&scoped=true"
import script from "./userExamPaper.vue?vue&type=script&lang=js"
export * from "./userExamPaper.vue?vue&type=script&lang=js"
import style0 from "./userExamPaper.vue?vue&type=style&index=0&id=7e604e69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e604e69",
  null
  
)

export default component.exports